/* eslint-disable jsx-a11y/anchor-is-valid */
import { IonPage } from '@ionic/react';
import classNames from 'classnames';
import React, { useState } from 'react';
import { Header } from './Header';
import styles from './SelectUserPopup.module.css';
import { IconButton } from './IconButton';
import { IconChatbox, IconClose, IconProfile, IconSpinner } from './QuirkIcons';
import { useLazySearchRecipientsQuery } from '../api/DirectMessageApi.js';
import { ProfilePic } from './ProfilePic.js';
import { User } from 'model';
import { SearchBar } from './Forms/SearchBar.js';
import { QuirkLoader } from './QuirkLoader.js';
import { NoResults } from './NoResults.js';
import { QuirkIonContent } from './QuirkIonContent.js';
import { useQueryWithDebounce } from '../hooks/useQueryWithDebounce.js';
import { QuirkVirtualList } from './QuirkVirtualList.js';

export type SendMessagePopupProps = {
	onDismiss: () => void;
	onSelectRecipient: (user: User) => void;
};

const SelectUserItem: React.FC<{ item: User; onSelectRecipient: (user: User) => void }> = ({
	item,
	onSelectRecipient
}) => {
	return (
		<div
			className={styles.user}
			onClick={() => onSelectRecipient(item)}
			key={item._id}
			data-testid={`SelectUser-${item._id}`}
		>
			<ProfilePic user={item} size="small" key={item._id} disableClick />
			<span className={styles.username}>{item.username}</span>
			<IconButton icon={<IconChatbox />} iconColor={'var(--primary)'} />
		</div>
	);
};

export const SelectUserPopup: React.FC<SendMessagePopupProps> = ({ onDismiss, onSelectRecipient }) => {
	const [search, setSearch] = useState<string>('');
	const { data, isLoading, isFetching, trigger } = useQueryWithDebounce(useLazySearchRecipientsQuery, 300);
	const users = search === '' ? [] : data;
	return (
		<>
			<IonPage>
				<>
					<Header
						title="Start conversation"
						left={<IconButton icon={<IconClose />} onClick={() => onDismiss()} />}
					/>
					<QuirkIonContent fullscreen flush>
						<>
							<div className={classNames(styles.search)}>
								<SearchBar
									testId={'searchUsersSearchBar'}
									placeholder="Search for a user by username"
									value={search}
									isFetching={isFetching}
									isLoading={isLoading}
									onChangeAction={event => {
										setSearch(event.detail.value as string);
										trigger(event.detail.value as string);
									}}
								/>
							</div>
							<QuirkLoader
								isLoading={isLoading}
								data={users}
								noResults={
									search === '' || isLoading || isFetching ? (
										<></>
									) : (
										<NoResults compact heading="No users found." icon={<IconProfile />} />
									)
								}
							>
								<QuirkVirtualList
									items={users}
									ItemComponent={({ item }) => (
										<SelectUserItem item={item} onSelectRecipient={onSelectRecipient} />
									)}
								/>
							</QuirkLoader>
							{isLoading && (
								<div>
									<IconSpinner />
								</div>
							)}
						</>
					</QuirkIonContent>
				</>
			</IonPage>
		</>
	);
};
